import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

export const pageTitleSuffix = ' - Dusky';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private titleService = inject(Title);

  setTitle(title: string): void {
    this.titleService.setTitle(`${title}${pageTitleSuffix}`);
  }
}
